import React from 'react';
import { XIcon } from 'lucide-react';
const problems = ['You end up improvising every meal.', 'You keep eating the same foods over and over.', 'You waste time searching for recipes.', "You feel frustrated because you're never sure if you're making the right choices.", 'Food becomes another source of daily stress.'];
export function ComparisonTable() {
  return <section className="py-8 sm:py-12 px-4 bg-brand-cream" data-id="element-27">
      <div className="max-w-3xl mx-auto" data-id="element-28">
        <h2 className="text-3xl sm:text-4xl font-serif font-bold text-center text-brand-text-dark mb-6" data-id="element-29">
          Without a Plan, Everything Becomes More Difficult
        </h2>

        <div className="space-y-3 mb-6" data-id="element-30">
          {problems.map((problem, i) => <div key={i} className="flex gap-3 items-start bg-white p-4 rounded-lg border border-brand-sage/30" data-id="element-31">
              <XIcon className="w-5 h-5 text-red-500 shrink-0 mt-0.5" strokeWidth={3} data-id="element-32" />
              <p className="text-base text-brand-text-dark" data-id="element-33">{problem}</p>
            </div>)}
        </div>

        <div className="text-center space-y-2 text-lg text-brand-text-muted" data-id="element-34">
          <p data-id="element-35">Not because you don't care.</p>
          <p data-id="element-36">
            But because nobody ever showed you a simple way to organize your
            meals.
          </p>
        </div>
      </div>
    </section>;
}